<template>
  <section class="play" :class="{ 'is-webp': isWebpSupported }">
    <div class="main-container">
      <div ref="dude" class="play__dude"></div>
      <h2 class="play__header heading js-reveal">100% free, play now!</h2>
      <play-buttons class="play__button-wrap js-reveal" />
      <div class="play__separator js-reveal"></div>
    </div>
  </section>
</template>
<script>
import PlayButtons from "../common/PlayButtons";
import { mapGetters } from "vuex";

export default {
  components: { PlayButtons },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("settings", {
      isWebpSupported: "isWebpSupported"
    })
  }
};
</script>
<style scoped lang="scss" type="text/scss">
@import "../../../assets/styles/vars";
@import "../../../assets/styles/mixins";
.play {
  position: relative;
  font-size: 1rem;
  padding: 4em 0 5em;
  background: url("../../../assets/img/bg/bg-play-now.jpg") center no-repeat;
  background-size: cover;
  text-align: center;

  @media (max-width: $screen-xl-down) {
    background-image: url("../../../assets/img/bg/bg-play-now.jpg?size=1920");
    font-size: 0.8rem;
  }

  @media (max-width: $screen-lg-down) {
    background-image: url("../../../assets/img/bg/bg-play-now.jpg?size=1280");
    font-size: 0.65rem;
  }

  @media (max-width: $screen-md-down) {
    background-image: url("../../../assets/img/bg/bg-play-now.jpg?size=1024");
    font-size: 0.8rem;
  }

  @media (max-width: $screen-sm-down) {
    background-image: url("../../../assets/img/bg/bg-play-now.jpg?size=768");
    font-size: 0.65rem;
  }

  &.is-webp {
    background: url("../../../assets/img/bg/bg-play-now.webp") center no-repeat;
    @media (max-width: $screen-xl-down) {
      background-image: url("../../../assets/img/bg/bg-play-now.webp?size=1920");
    }
    @media (max-width: $screen-lg-down) {
      background-image: url("../../../assets/img/bg/bg-play-now.webp?size=1280");
    }
    @media (max-width: $screen-md-down) {
      background-image: url("../../../assets/img/bg/bg-play-now.webp?size=1024");
    }
    @media (max-width: $screen-sm-down) {
      background-image: url("../../../assets/img/bg/bg-play-now.webp?size=768");
    }
  }
}

.play__dude {
  position: absolute;
  left: 40px;
  top: -55%;
  width: 27.07143em;
  height: 28.57143em;
  background-image: url("../../../assets/img/dude.png");
  background-size: contain;

  @media (max-width: $screen-xl-down) {
    top: -70%;
  }

  @media (max-width: $screen-md-down) {
    display: none;
    background-image: none !important;
  }
}

.play__header {
  font-size: 2.25em;
  text-transform: uppercase;
  margin-bottom: 0.8em;
  letter-spacing: 0.08em;

  @media (max-width: $screen-xl-down) {
    font-size: 1.75em;
  }
}

.play__button-wrap {
  position: relative;
  margin-bottom: 2.5em;
}

.play__button {
}

.play__separator {
  display: inline-block;
  width: em(270);
  height: 2px;
  background-color: $mainRed;
}
</style>
